export default __webpack_public_path__ + "static/media/transfer_navicon.f8bb348b.svg";